enum UserTitle {
  NA = 'N/A',
  DR = 'Dr.',
  PROF = 'Prof.',
  PROF_DR = 'Prof. Dr.',
}

enum UserTitleKey {
  NA = 'NA',
  DR = 'DR',
  PROF = 'PROF',
  PROF_DR = 'PROF_DR',
}

export { UserTitle, UserTitleKey };
